/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { DivisionProcessTypes } from './Actions';
import INITIAL_STATE from './InitialState';

export const divisionProcessFetchDivisionProcessLoading = (state, { boolean }) => ({
  ...state,
  processIsLoading: boolean
});

export const divisionProcessFetchDivisionProcessSuccess = (state, { process }) => ({
  ...state,
  process
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [DivisionProcessTypes.DIVISION_PROCESS_FETCH_DIVISION_PROCESS_LOADING]: divisionProcessFetchDivisionProcessLoading,
  [DivisionProcessTypes.DIVISION_PROCESS_FETCH_DIVISION_PROCESS_SUCCESS]: divisionProcessFetchDivisionProcessSuccess
});
